module.exports = __webpack_public_path__ + "media/images/canceled-cec29cd84d4c0f4d4c4ad81739887d4f.svg";